import { Values } from '../../../../../types/Survey/Analysis/Calculation'
import {
  ResultPropsEinzelbueros,
  ResultPropsSonderbedarfe,
  ResultPropsStauflaeche,
  ResultPropsUebergeordneteBedarfe,
  ResultPropsWorkstation,
} from '../../../../../types/Survey/Analysis/FactorValues'
import { Answer } from '../../../../../types/Survey/Answer/Answer'
import {
  DynamicNumberDescriptionAmountInput,
  AmountToggleInput,
  NumberInput,
  OrganizationUnitNumberInput,
  DynamicOptionsWithNumberAndSelection,
} from '../../../../../types/Survey/Answer/Element'
import { PrebuildType, DynamicOptionsWithNumberAndSelection as DynamicOptionsWithNumberAndSelectionSurvey } from '../../../../../types/Survey/Element'
import { Survey } from '../../../../../types/Survey/Survey'

const emptyResult = {
  practicalQM: 0,
  originalPracticalQM: 0,
}

const emptyResultArray = []

const emptyAmountResult = {
  amount: 0,
  originalAmount: 0,
}

export const getStaufleache = (values: Values): ResultPropsStauflaeche => {
  // if values are already set return it
  if (!!values[PrebuildType.STAUFLAECHE]) return values[PrebuildType.STAUFLAECHE]

  const survey = values.managerSurvey
  const answer = values.managerAnswer
  if (!answer) return emptyResult
  const prebuildType = PrebuildType.STAUFLAECHE
  const surveyElementUUID = survey.elements.find((e) => e.prebuildType === prebuildType)?.uuid
  if (!surveyElementUUID) return emptyResult
  const answerElement = answer.elements.find((e) => e.uuid === surveyElementUUID) as NumberInput
  if (!answerElement) return emptyResult
  return {
    practicalQM: (answerElement.number * 0.45) / 3,
    originalPracticalQM: (answerElement.number * 0.45) / 3,
  }
}

export const getStaufleacheLaufmeter = (value: number): number => {
  return (value / 0.45) * 3
}

export const getSonderbedarfe = (values: Values): ResultPropsSonderbedarfe[] => {
  // if values are already set return it
  if (!!values[PrebuildType.SONDERBEDARFE]) return values[PrebuildType.SONDERBEDARFE]

  const survey = values.managerSurvey
  const answer = values.managerAnswer

  if (!answer) return emptyResultArray
  const prebuildType = PrebuildType.SONDERBEDARFE
  const surveyElementUUID = survey.elements.find((e) => e.prebuildType === prebuildType)?.uuid
  if (!surveyElementUUID) return emptyResultArray
  const answerElement = answer.elements.find((e) => e.uuid === surveyElementUUID) as DynamicNumberDescriptionAmountInput
  if (!answerElement) return emptyResultArray
  return answerElement.numberAnswers.map((n) => ({
    name: n.description,
    practicalQM: n.number * n.amount,
    originalPracticalQM: n.number,
    originalAmount: n.amount,
  }))
}

export const getWorkstations = (values: Values): ResultPropsWorkstation => {
  // if values are already set return it
  if (!!values[PrebuildType.WORKSTATIONS]) return values[PrebuildType.WORKSTATIONS]

  const survey = values.managerSurvey
  const answer = values.managerAnswer

  if (!answer) return emptyAmountResult
  const prebuildType = PrebuildType.WORKSTATIONS
  const surveyElementUUID = survey.elements.find((e) => e.prebuildType === prebuildType)?.uuid
  if (!surveyElementUUID) return emptyAmountResult
  const answerElement = answer.elements.find((e) => e.uuid === surveyElementUUID) as AmountToggleInput
  if (!answerElement || !answerElement.isEnabled) return emptyAmountResult
  return {
    amount: answerElement.amount || 0,
    originalAmount: answerElement.amount || 0,
  }
}

export const getEinzelbueros = (values: Values): ResultPropsEinzelbueros => {
  const empty = {
    amount: 0,
    originalAmount: 0,
    practicalQM: 0,
  }

  // if values are already set return it
  if (!!values[PrebuildType.EINZELBUEROS]) {
    return {
      amount: values[PrebuildType.EINZELBUEROS].amount || 0,
      originalAmount: values[PrebuildType.EINZELBUEROS].originalAmount || 0,
      practicalQM: (values[PrebuildType.EINZELBUEROS].amount || 0) * values.factor.einzelbueroQM.value,
    }
  }

  const survey = values.leaderSurvey
  const answer = values.leaderAnswer
  if (!answer) return empty
  const prebuildType = PrebuildType.EINZELBUEROS
  const surveyElementUUID = survey.elements.find((e) => e.prebuildType === prebuildType)?.uuid

  if (!surveyElementUUID) return empty
  const answerElement = answer.elements.find((e) => e.uuid === surveyElementUUID) as OrganizationUnitNumberInput
  if (!answerElement) return empty
  const unitValues = answerElement.organizationUnitNumberInputList.find((e) => e.organizationUnitUUID === values.unitUUID)
  if (!unitValues || isNaN(unitValues.number)) return empty
  return {
    amount: unitValues.number,
    originalAmount: unitValues.number,
    practicalQM: unitValues.number * values.factor.einzelbueroQM.value,
  }
}

export const getUebergeordneteBedarfe = (leaderSurvey: Survey, leaderAnswer: Answer): ResultPropsUebergeordneteBedarfe[] => {
  if (!leaderAnswer) return emptyResultArray
  const prebuildType = PrebuildType.UEBERGEORDNETE_BEDARFE
  const surveyElement = leaderSurvey.elements.find((e) => e.prebuildType === prebuildType) as DynamicOptionsWithNumberAndSelectionSurvey
  if (!surveyElement) return emptyResultArray
  const answerElement = leaderAnswer.elements.find((e) => e.uuid === surveyElement.uuid) as DynamicOptionsWithNumberAndSelection
  if (!answerElement) return emptyResultArray
  const selectedOptions = answerElement.dynamicOptionsWithNumberAndSelection.filter((o) => o.isActive)

  return selectedOptions.map((o) => ({
    uuid: o.uuid,
    name: o.name,
    practicalQM: o.number,
    isNormSelected: o.isNormSelected,
    originalPracticalQM: o.number,
  }))
}
